export const LOCAL_STORAGE_PREFIX = ['localStorage']
export const GLOBAL_PREFIXES = [
  ['application'],
  ['queries'],
  LOCAL_STORAGE_PREFIX,
]
export const PATH_MODE = 'dot'
